import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class MessageSearchTask extends GenericRequest {

    _request; // MessagesSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MESSAGES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/shared/message-search/MessageSearchTask.js